import React from 'react';
import styled from 'styled-components';

import Wrapper from 'components/wrapper';
import MetaTags from 'components/meta-tags';

import useDispensary from 'src/dispensary/hooks/use-dispensary';

import useViewport from 'hooks/use-viewport';
import useUI from 'hooks/use-ui';

import SearchLocation from './search-location';
import DispensaryChainResult from './dispensary-chain-result';
import { useLocations } from './use-locations';

const Locations = () => {
  const { dispensary } = useDispensary();
  const logoImage = dispensary?.logoImage;
  const viewport = useViewport();
  const UI = useUI();

  const containerProps = {
    isIframe: UI.isIframe,
    iframeOffset: viewport.offset,
    parentOffset: viewport.parentOffset,
    viewportHeight: viewport.height,
    viewportWidth: viewport.width,
    iframeHeight: UI.iframeHeight,
  };

  const {
    nearestDispensaryLocation,
    handleChangeAddress,
    address,
    handleClearAddress,
    searchByDeliveryArea,
    loading,
    hasErrors,
  } = useLocations();

  if (hasErrors) {
    return null;
  }

  return (
    <Wrapper>
      <MetaTags />

      <Container>
        {!address || searchByDeliveryArea ? (
          <SearchLocation
            address={address}
            logoImage={logoImage}
            onChangeAddress={handleChangeAddress}
            containerProps={containerProps}
          />
        ) : (
          <DispensaryChainResult
            nearestDispensaryLocation={nearestDispensaryLocation}
            onClearAddress={handleClearAddress}
            containerProps={containerProps}
            loading={loading}
          />
        )}
      </Container>
    </Wrapper>
  );
};

export default Locations;

const Container = styled.div`
  height: 1000px;
`;
